import React, { useEffect, useState } from 'react';
import CorrectAnswer from './CorrectAnswer';
import ProgressBar from './ProgressBar';
import ScoreBoard from './Scoreboard';
import SecurityExpert from './SecurityExpert';
import { useTranslation } from 'react-i18next';
import useGame from '../hooks/useGame';
import MultipleChoiceAnswer from './MultipleChoiceAnswer';
import SkipVideo from './SkipVideo';
import VideoFilesFullLoop from "./VideoFilesFullLoop";
import MobileVideoButton from './MobileVideoButton';
import { trackPageView } from '../helpers/gaHelper';

const Question3 = () => {
   const { PUBLIC_URL, REACT_APP_LANGUAGE } = process.env;
  const { t } = useTranslation();
  const { addScore, trackGTMEvent } = useGame();

  useEffect(() => {
    trackPageView('/question/3');
  },[]);

  // wait
  async function wait(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  const [hasAnswered, setHasAnswered] = useState(false);
  const [score, setScore] = useState(4);

  const addBodyClass = className => document.body.classList.add(className);
  const removeBodyClass = className => document.body.classList.remove(className);

  useEffect(() => {
    const show = async () => {
      if (hasAnswered) {
        // show the screen after 1 second
        await wait(1000);
        addBodyClass('fade-in-correct');

        return () => {
          removeBodyClass('fade-in-correct')
        }
      }
    }
    show();
  }, [hasAnswered])

  const handleAnswer = (isCorrect) => {
    if(isCorrect) {
      setHasAnswered(true)
      addScore(score);
    }
    else {
      setScore(score-1);
    }
  }

  // attach the main.js file
 useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    trackGTMEvent(3);
  }, []);

  return (
    <main>
      <section className="question type-1">
        <div className="inner">
          <ScoreBoard />
          <ProgressBar question={3} />
          <SecurityExpert text={t('questions.3.expert')}/>

          <MobileVideoButton className="q3" />
          <VideoFilesFullLoop page='q3' id='q3-video' />

          <div className="loop-screen q3" />
          <SkipVideo />

          <div className="question-wrapper">
            <h1>{t('questions.3.title')}</h1>
            <div className="select">
              <MultipleChoiceAnswer text={t('questions.3.answers.A')} symbol={'A'} isCorrect={false} onClick={handleAnswer} />
              <MultipleChoiceAnswer text={t('questions.3.answers.B')} symbol={'B'} isCorrect={false} onClick={handleAnswer} />
              <MultipleChoiceAnswer text={t('questions.3.answers.C')} symbol={'C'} isCorrect={false} onClick={handleAnswer} />
              <MultipleChoiceAnswer text={t('questions.3.answers.D')} symbol={'D'} isCorrect={true} onClick={handleAnswer} />
            </div>
          </div>

          {hasAnswered && (
            <CorrectAnswer question={3} isPlaying={hasAnswered} scoreTier={5 - score} />
          )}

        </div>
      </section>
    </main>
  )
}

export default Question3;
